import GetRfqDetails from '../../../../../../client/src/rfq/src/viewmodel/GetRfqDetailsViewModel';
import { DesBaseRfq } from '../utils/des-base-rfq';

export default class DesGetRfqDetails extends DesBaseRfq {

    constructor() {
        console.log('DesGetRfqDetails invoked');
        super(GetRfqDetails);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfq.observedAttributes];
    }
}

if (!window.customElements.get('des-get-rfq-details')) {
    window.customElements.define('des-get-rfq-details', DesGetRfqDetails);
}
